import React from "react";

const Button = (props) => {
  const { children, ...buttonProps } = props;
  return <input type="submit" className="submit-btn" {...buttonProps} />;
};

export default Button;
